/* eslint-disable */
import React from 'react';
import { connect } from 'react-redux';
import _debounce from 'lodash/debounce';
import classNames from 'classnames';
import { isElementVisible } from 'lib/ui';
import { adsRefreshed } from './actions';

class AdContainer extends React.Component {
    constructor(props) {
        super(props);
        this.refreshAds = this.refreshAds.bind(this);
        this.onWindowScroll = this.onWindowScroll.bind(this);
        this.state = {
            refreshed: false
        };
    }

    componentDidMount() {
        // listen to scroll events for ads that are not initially visible
        if (this.props.refreshWhenVisible === true) {
            window.addEventListener('scroll', _debounce(this.onWindowScroll, 100));
        }
    }

    componentWillReceiveProps(nextProps) {
        // refresh initially visible ads as early as possible.  also refresh for media queries
        if (this.props.mq !== nextProps.mq) {
            // this.adManager.refreshAll();
            this.refreshAds(nextProps);
        }
    }

    // check if the elemtn is visible on screen, if so, refresh ad and stop listening
    onWindowScroll() {
        if (this.state.refreshed === false && isElementVisible(this.refs.adSlot)) {
            this.refreshAds(this.props);
            window.removeEventListener('scroll', this.onWindowScroll);
            this.setState({ refreshed: true });
        }
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.ads.id === nextProps.ads.id) {
            return false;
        }
        return true;
    }

    refreshAds(props = {}) {
        const { ads } = props;
        // find the GPT (Google Publisher Tag) slot that matches this element and refresh it
        if (ads.id && ads.configured && ads.initialized) {
            const gptArray = (admgr.getGPTArray({independent: false}) || [])
                .filter((gptElement) => {
                    if (this.refs.adSlot.id === gptElement.getSlotElementId()) {
                        return true;
                    }
                });
            if (gptArray.length > 0) {
                admgr.refresh(gptArray);
            }
            this.setState({ refreshed: true});
        }
    }

    render() {
        const {
            className,
            collapseBeforeLoad,
            exclude,
            id,
            include,
            inView,
            isOutOfPage,
            kvps,
            refreshWhenVisible,
            slotType
        } = this.props;

        const slotKvps = [];
        const adProps = { id, key: id };

        /* no type no ad */
        if (slotType === null) {
            return null;
        }

        /* default if pos not specified */
        if (typeof kvps.pos === 'undefined') {
            kvps.pos = slotType;
        }

        /* build key value pair string */
        for (const key in kvps) {
            if (key !== null && kvps.k !== null) {
                slotKvps.push(`${key}=${kvps[key]}`);
            }
        }

        /* build up the div properties */
        adProps.className = classNames('react-ad', className, {
            'ad-slot': !inView
        });

        adProps['data-slot-type'] = slotType;

        if (isOutOfPage) {
            adProps['data-out-of-page'] = 'true';
        }

        if (collapseBeforeLoad) {
            adProps['data-collapse-before-load'] = 'true';
        }

        if (include.length > 0) {
            const includeStr = include.join(',');
            adProps['data-include-bp'] = includeStr;
        }

        if (exclude.length > 0) {
            const excludeStr = exclude.join(',');
            adProps['data-exclude-bp'] = excludeStr;
        }

        if (slotKvps.length > 0) {
            const kvpsStr = slotKvps.join(',');
            adProps['data-slot-kvps'] = kvpsStr;
        }

        if (refreshWhenVisible === false ) {
            adProps['data-refresh-on-pageload'] = 'true';
        }

        return (
            <div ref="adSlot" {...adProps} />
        );
    }
}

AdContainer.defaultProps = {
    className: '',
    exclude: [],
    include: [],
    inView: false,
    kvps: {},
    refreshWhenVisible: false,
    slotType: null
};

const mapStateToProps = (state) => ({
    ads: state.ads,
    mq: state.app.mq
});

export default connect(mapStateToProps)(AdContainer);



// WEBPACK FOOTER //
// ./app/ads/AdContainer.js